const STORAGE_KEY = 'vwoFavoriteAddedConversion';

export function storeFavoriteAddedConversion(conversionURL?: string) {
  if (typeof window === 'undefined') return;
  if (conversionURL) {
    localStorage.setItem(STORAGE_KEY, conversionURL);
  } else {
    localStorage.removeItem(STORAGE_KEY);
  }
}

export function consumeFavoriteAddedConversion() {
  if (typeof window === 'undefined') return;
  const conversionURL = localStorage.getItem(STORAGE_KEY);
  if (conversionURL) {
    localStorage.removeItem(STORAGE_KEY);
  }
  return conversionURL || undefined;
}
